module.exports = __webpack_public_path__ + "img/cardseyeless.74844d77.svg";